import script from "./SupportMessagesAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportMessagesAdmin.vue?vue&type=script&setup=true&lang=js"

import "./SupportMessagesAdmin.vue?vue&type=style&index=0&id=3e170f0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e170f0a"]])

export default __exports__